import React from "react";

import { Box, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

interface DotGridProps {
  children?: React.ReactNode;
  sx?: object;
}

/**
 * Static dot-grid background (Surfaces P7: "The Grid is Invisible but Present").
 *
 * A 40px radial-gradient at 2% opacity underlies the page, providing texture
 * without pattern fatigue. This is the subtle static grid from the
 * design-system-surfaces skill — NOT the animated tech-circuit-bg in
 * theme-overrides/layout.ts (which the audit flagged for color restraint
 * violations).
 */
export function DotGrid({ children, sx }: DotGridProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundImage: `radial-gradient(${alpha(theme.palette.text.primary, 0.02)} 1px, transparent 1px)`,
        backgroundSize: "40px 40px",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default DotGrid;
